import { OutOfPocketMaxState, QmeState } from "#/lib/carrot-api/types/Subsidy"
import { Percentages } from "../hooks/useReimbursementRulePercentages"
import { PiiText } from "#/services/tracking"
import { Typography } from "@carrotfertility/carotene-core"
import React, { FC } from "react"
import { FormattedMessage } from "react-intl"

type YourCostShareSingleRuleProps = {
  companyDisplayName: string
  isDefaultCategory: boolean
  getPercentages: (qme: QmeState, oop: OutOfPocketMaxState) => Percentages
}

export const YourCostShareSingleRule: FC<YourCostShareSingleRuleProps> = ({
  companyDisplayName,
  isDefaultCategory,
  getPercentages
}) => {
  const percentages = getPercentages(QmeState.ANY, OutOfPocketMaxState.ANY)
  return (
    <Typography>
      {isDefaultCategory ? (
        <FormattedMessage
          defaultMessage="{companyDisplayName} will cover {companyResponsibilityPercent, number, ::percent} of each approved expense."
          values={{
            companyDisplayName: <PiiText>{companyDisplayName}</PiiText>,
            companyResponsibilityPercent: percentages.companyResponsibility / 100
          }}
        />
      ) : (
        <FormattedMessage
          defaultMessage="{companyDisplayName} will cover {companyResponsibilityPercent, number, ::percent} of each approved expense in this category."
          values={{
            companyDisplayName: <PiiText>{companyDisplayName}</PiiText>,
            companyResponsibilityPercent: percentages.companyResponsibility / 100
          }}
        />
      )}
    </Typography>
  )
}
